import BaseAnswer from "./BaseAnswer";

export default class {
    constructor(dto) {

        this.Name = dto.Name
        this.QuestionId = dto.QuestionId;
        this.IsRequired = dto.IsRequired;
        this.IsAnswered = dto.IsAnswered;
        this.AnswerType = dto.AnswerType;
        this.Id = dto.Id;
        this.UpdatedAt = dto.UpdatedAt;
        this.SubVisiblePoliticList = dto.SubVisiblePoliticList;       
        
        this.IsVisible = false;
        
        this.IsText =   dto.AnswerType === 1;
		this.IsNumber = dto.AnswerType === 10;
		this.IsDecimal = dto.AnswerType === 11;
		this.IsPercent = dto.AnswerType === 12;
		this.IsSelect = dto.AnswerType === 20;
        this.IsMultipleSelect = dto.AnswerType === 21 || dto.AnswerType === 23 || dto.AnswerType === 24;
		this.IsSmallSelect = dto.AnswerType === 22;
		this.IsContact = dto.AnswerType === 30;
		this.IsBoolSelect = dto.AnswerType === 40;
        this.IsAep = dto.AnswerType > 100;
        
        this.IsMultipleAnswer = this.IsMultipleSelect || this.IsAep;
        this.IsBlockSubQuestions = !this.IsMultipleSelect && !this.IsAep;

        this.AnswerList = dto.AnswerList.map(e => new BaseAnswer(e));

        this.Options = [];

        if(this.IsSelect || this.IsMultipleSelect || this.IsAep || this.IsSmallSelect)
            this.Options = this.AnswerList.map(e => e.Value);
    }

    getTrackBy = function() {
        return this.IsAep ? "Id" : "Key";
    }

    getLabel = function() {
        return this.IsAep ? "Name" : "Value";
    }
}